import { requestPreviousState, requestState } from '../redux/reducer/content'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { MAIN, INTERACTIVE_SHOP } from '../constants/shared/states/names'

/**
 * Набор методов для управления состоянием приложения (SPA-навигация).
 * Доступные состояния определены в 'constants/states'.
 *
 * @typedef {Object} StateControls
 * @property {Function} setPrevState Переводит приложение в предыдущее состояние.
 * @property {(state: string) => void} setState Устанавливает произвольное состояние приложения.
 */

/**
 * Хук для управления состояниями приложения.
 *
 * @function useStateControls
 * @returns {StateControls} Методы управления состоянием.
 *
 * @example
 * const { setState } = useStateControls();
 * // На главную
 * setState('main');
 */
export default function useStateControls() {
  const dispatch = useDispatch()

  const setState = useCallback(
    (state) => {
      if (state === 'nyTask' || state === 'roadmap' || state === INTERACTIVE_SHOP) {
        dispatch(requestState(MAIN))
        return
      }
      dispatch(requestState(state))
    },
    [dispatch],
  )
  const setPrevState = useCallback(() => dispatch(requestPreviousState()), [])

  return { setState, setPrevState }
}
